import { useEffect } from "react";
import { trackEvent } from "./analytics";

const SECTION_VIEW_THRESHOLD = 0.5;

export const useSectionViewTracking = (): void => {
  useEffect(() => {
    if (!import.meta.env.PROD || !import.meta.env.VITE_GA_MEASUREMENT_ID) {
      return;
    }

    const seen = new Set<string>();
    const sections = document.querySelectorAll("section[id]");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < SECTION_VIEW_THRESHOLD) {
            return;
          }

          const sectionId = entry.target.id;
          if (!sectionId || seen.has(sectionId)) {
            return;
          }

          seen.add(sectionId);
          trackEvent("section_view", { section_id: sectionId });
        });
      },
      { threshold: SECTION_VIEW_THRESHOLD }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);
};
